import React from "react";
import Icon from "components/AppIcon";

const MarketStats = ({ stocks }) => {
  const gainers = stocks?.filter(s => s?.change > 0)?.length;
  const losers = stocks?.filter(s => s?.change < 0)?.length;
  const totalVol = stocks?.reduce((a, s) => a + s?.volume, 0);
  const topGainer = [...stocks]?.sort((a, b) => b?.change - a?.change)?.[0];
  const topLoser = [...stocks]?.sort((a, b) => a?.change - b?.change)?.[0];
  const avgChange = stocks?.reduce((a, s) => a + s?.change, 0) / stocks?.length;

  const stats = [
    { label: "Gainers", value: gainers, icon: "TrendingUp", color: "#34d399" },
    { label: "Losers", value: losers, icon: "TrendingDown", color: "#f87171" },
    { label: "Total Volume", value: `${(totalVol / 1000)?.toFixed(0)}K`, icon: "Activity", color: "var(--color-primary)" },
    { label: "Avg Change", value: `${avgChange >= 0 ? "+" : ""}${avgChange?.toFixed(2)}%`, icon: "BarChart2", color: avgChange >= 0 ? "#34d399" : "#f87171" },
    { label: "Top Gainer", value: topGainer ? `${topGainer?.ticker} +${topGainer?.change?.toFixed(1)}%` : "-", icon: "Star", color: "#fbbf24" },
    { label: "Top Loser", value: topLoser ? `${topLoser?.ticker} ${topLoser?.change?.toFixed(1)}%` : "-", icon: "AlertCircle", color: "#f87171" },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 p-4 border-b border-border">
      {stats?.map((stat, i) => (
        <div key={i} className="flex items-center gap-3 p-3 rounded-lg bg-secondary border border-border">
          <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: stat?.color + "22" }}>
            <Icon name={stat?.icon} size={14} color={stat?.color} />
          </div>
          <div className="min-w-0">
            <div className="font-caption text-xs text-muted-foreground truncate">{stat?.label}</div>
            <div className="font-data text-sm font-semibold truncate" style={{ color: stat?.color }}>{stat?.value}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MarketStats;